import { Center, CircularProgress, HStack, Text, VStack } from '@chakra-ui/react'
import { colors } from '@hb/shared'

import { useAuth } from '@hb/react'
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { FloatingContainer } from '../Containers/FloatingContainer'
import { LoadingOverlay } from '../LoadingOverlay'

export const RedirectView = () => {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)
  const navigate = useNavigate()

  const loading = useAuth(s => s.loading)
  useEffect(() => {
    if (!loading) {
      timer.current = setTimeout(() => {
        navigate('/')
      }, 1500)
    }
    return () => {
      if (timer.current) clearTimeout(timer.current)
    }
  }, [loading, navigate])

  return !loading ? (
    <Center w="100%">
      <FloatingContainer maxW="500px">
        <HStack spacing={3}>
          <CircularProgress isIndeterminate size={6} color={colors.green.hex} />
          <VStack spacing={0} align="flex-start">
            <Text fontFamily="Open Sans">404</Text>
            <Text fontFamily="Open Sans" fontSize="sm" color="gray.600">
              Page not found - redirecting to Home...
            </Text>
          </VStack>
        </HStack>
      </FloatingContainer>
    </Center>
  ) : (
    <LoadingOverlay loading={true} />
  )
}
